<div tabindex="0" cdkTrapFocus class="ds-grid lead-form-container px-0" (click)="$event.stopPropagation()">
  <form #leadForm="ngForm" (ngSubmit)="onSubmit()" *ngIf="userType">
    <div class="text-end">
      <em
        (click)="launchDialogService.closeDialog('Cross click')"
        (keydown.enter)="launchDialogService.closeDialog('Cross click')"
        [tabindex]="0"
        class="ds-icon ds-icon--close ds-icon--big focusable focusable__element close-dialog-button"
        data-cta="close form"
      ></em>
    </div>
    <div class="row mx-0">
      <div class="col-lg-4 lead-form-info py-4 py-lg-7 px-5">
        <dcp-lead-form-product-details
          [image]="image"
          [product]="product"
          [showCtaFrom]="showCtaFrom"
          [transactionType]="transactionType"
        ></dcp-lead-form-product-details>
      </div>
      <div class="col-lg-8 lead-form-content py-4 px-5 p-lg-5">
        <dcp-lead-form-header [ctaLabel]="transactionType?.ctaLabel" class="mb-0"></dcp-lead-form-header>
        <div class="d-flex flex-column">
          <div *ngIf="product?.vendor" class="d-lg-flex flex-nowrap ds-body d-none">
            <ng-container *ngIf="showCtaFrom">{{'productDetails.from' | cxTranslate}}</ng-container>
            <span [ngClass]="{'ms-1': showCtaFrom}">{{product?.vendor?.name}}</span>
          </div>
        </div>
        <div class="w-100 separator d-none d-lg-block mt-4"></div>
        <ng-container *ngIf="!showSuccessMessage">
          <div class="row">
            <div class="col">
              <dcp-lead-form-user-status
                [sapEmployeeSubject]="sapEmployeeSubject"
                [transactionListCta]="transactionListCta"
                [transactionType]="transactionType"
                [user]="user">
              </dcp-lead-form-user-status>
            </div>
          </div>
          <div class="row mt-lg-1">
            <ng-container *ngIf="!isEmployeeForm">
              <ng-container *ngTemplateOutlet="personDetailsCol"></ng-container>
              <ng-container *ngTemplateOutlet="companyDetailsCol"></ng-container>
            </ng-container>
            <ng-container *ngIf="isEmployeeForm && !shouldShowContractDetailsColumn">
              <ng-container *ngTemplateOutlet="companyDetailsCol"></ng-container>
              <ng-container *ngTemplateOutlet="personDetailsCol"></ng-container>
            </ng-container>
            <ng-container *ngIf="shouldShowContractDetailsColumn">
              <ng-container *ngTemplateOutlet="personDetailsCol"></ng-container>
              <ng-container *ngTemplateOutlet="companyDetailsCol"></ng-container>
              <ng-container *ngTemplateOutlet="contractDetailsCol"></ng-container>
            </ng-container>
          </div>
          <div class="row">
            <div class="col">
              <div data-cy="input">
                <ds-textarea
                  [(ngModel)]="leadFormModel.comment"
                  [disabled]="userType.isEmployeeLogin"
                  [error]="{message: 'leadForm.errors.tooLong' | cxTranslate, iconClass:'ds-icon--close-outline'}"
                  [label]="'leadForm.fields.message' | cxTranslate"
                  [placeholder]="'leadForm.fields.message' | cxTranslate"
                  [showErrorMessages]="submitStatus.submitted"
                  class="my-5"
                  fieldName="message"
                  maxlength="255"
                  name="message">
                </ds-textarea>
              </div>
              <ng-container *ngIf="shareDataConsent.showDcpLeadFormConsent">
                <div [class.consent-red]="shareDataConsent.isShareDataConsentWarningRed">
                  <ds-checkbox
                    (change)="onConsentCheckboxChange($event)"
                    (keydown.enter)="onConsentCheckboxChange($event)"
                    [checked]=isConsentCheckboxChecked
                    [disabled]="userType.isEmployeeLogin"
                    [class.ds-form-error]="shareDataConsent.isShareDataConsentWarningRed"
                  >
                    <div
                      *ngIf="shareDataWithPartnersConsent?.description"
                      [innerHTML]="shareDataWithPartnersConsent.description"
                    ></div>
                    <div *ngIf="!shareDataWithPartnersConsent?.description">
                      {{'leadForm.consentDescription' | cxTranslate:{publisher: product?.vendor?.name} }}
                      <a
                        href="/privacy"
                        rel="noopener noreferrer"
                        target="_blank"
                      >{{'leadForm.privacyStatement' | cxTranslate}}</a>
                    </div>
                  </ds-checkbox>
                </div>
              </ng-container>
              <div hidden>
                <ds-checkbox>{{'leadForm.options.createAccountAndSaveDetails' | cxTranslate}}</ds-checkbox>
                <ds-checkbox>{{'leadForm.options.receiveMarketingCommunications' | cxTranslate}}</ds-checkbox>
              </div>
              <dcp-lead-form-error [response]="response"></dcp-lead-form-error>
              <re-captcha
                *ngIf="leadFormCaptchaFeatureToggle"
                #recaptchaRef="reCaptcha"
                siteKey="{{siteKey}}"
                size="invisible"
                (resolved)="reCaptchaSubmit($event)"
              ></re-captcha>
              <span id="{{transactionType?.code + '-' + transactionType?.pageId}}" data-cy="lead-form-submit">
                <button
                  [attr.data-cy]="transactionType?.code"
                  [dcpSubmitFormButton]="{
                    name: formName,
                    useCustomTrigger: true,
                    product: product
                  }"
                  [disabled]="submitStatus.isSubmitButtonDisabled"
                  dcpAutofocus
                  class="btn btn-primary"
                  data-cta="send form"
                  type="submit"
                >
                  {{transactionType?.ctaLabel?.replace('productDetails', 'leadForm') | cxTranslate}}
                </button>
              </span>
            </div>
          </div>
        </ng-container>
        <dcp-lead-form-success
          *ngIf="showSuccessMessage"
          [product]="product"
          [bundleTemplate]="bundleTemplate"
        ></dcp-lead-form-success>
      </div>
    </div>
    <ng-template #personDetailsCol>
      <div
        [class.mt-3]="isEmployeeForm"
        [class.mt-sm-0]="isEmployeeForm"
        [class]="shouldShowContractDetailsColumn? 'col-lf-4-1': 'col-sm-6'"
        class="col-person-details"
      >
        <dcp-lead-form-partner-details
          [leadFormModel]="leadFormModel"
          [sapEmployeeSubject]="sapEmployeeSubject"
          [shareDataConsent]="shareDataConsent"
          [submitStatus]="submitStatus"
          [transactionType]="transactionType"
          [transactionListCta]="transactionListCta"
          [userType]="userType"
          [emailValidationRegexp]="emailValidationRegexp"
          [shouldShowContractDetailsColumn]="shouldShowContractDetailsColumn"
        ></dcp-lead-form-partner-details>
      </div>
    </ng-template>
    <ng-template #companyDetailsCol>
      <div
        [class.mt-3]="!isEmployeeForm"
        [class.mt-sm-0]="!isEmployeeForm"
        [class]="shouldShowContractDetailsColumn? 'col-lf-4-2': 'col-sm-6'"
        class="col-company-details"
      >
        <dcp-lead-form-company-details
          [leadFormModel]="leadFormModel"
          [leadFormContractDataModel]="leadFormContractDataModel"
          [product]="product"
          [sapEmployeeSubject]="sapEmployeeSubject"
          [submitted]="submitStatus.submitted"
          [userType]="userType"
          [showContractDetails]="shouldShowContractDetailsColumn"
        ></dcp-lead-form-company-details>
      </div>
    </ng-template>
    <ng-template #contractDetailsCol>
      <div
        [class.mt-3]="isEmployeeForm"
        [class.mt-sm-0]="isEmployeeForm"
        class="col-lf-4-3 col-contract-details"
      >
        <dcp-lead-form-contract-details
          [leadFormContractDataModel]="leadFormContractDataModel"
          [sapEmployeeSubject]="sapEmployeeSubject"
          [submitted]="submitStatus.submitted"
          [userType]="userType"
        ></dcp-lead-form-contract-details>
      </div>
    </ng-template>
  </form>
</div>
